module.exports = __webpack_public_path__ + "static/original-mattress-5-a84da7606a0b86fdbe9aed86f772473c.png";